import React, { useContext } from "react"
import { ThemeContext } from "contexts/ThemeContext"
import Color from "color"
import { WordmarkSolid, WordmarkOutlined } from "svgs"
import styles from "./wordmark.module.scss"

let COUNT = 30
const DISTANCE = 1

const Wordmark = () => {
  const context = useContext(ThemeContext)
  let plusOrMinusTop = Math.random() < 0.5 ? -1 : 1
  let plusOrMinusLeft = Math.random() < 0.5 ? -1 : 1

  const createTrail = () => {
    let trail = []

    for (let i = 1; i <= COUNT; i++) {
      const style = {
        top: `${plusOrMinusTop * i * DISTANCE}vw`,
        left: `${plusOrMinusLeft * i * DISTANCE}vw`,
        zIndex: -i,
      }

      const outlineOpacity = (COUNT - i) / COUNT
      const outlineColor = Color(context.spot)
        .alpha(outlineOpacity)
        .string()

      trail.push(
        <div key={i} style={style} className={styles.trailItem}>
          <WordmarkOutlined outlineColor={outlineColor} />
        </div>
      )
    }

    return trail
  }

  return (
    <div style={{ height: `100%` }}>
      <div className={styles.wordmarkContainer}>
        <div className={styles.wordmark}>
          <WordmarkSolid />
        </div>
        <div className={styles.trail}>{createTrail()}</div>
      </div>
    </div>
  )
}

export default Wordmark
